import type { ReactNode } from 'react'
import { LogoMark } from '@/components/logo'

/**
 * Frame for the two pages that exist OUTSIDE the app shell — signing in and
 * enrolling. No navigation rail on purpose: there is nowhere else to go yet,
 * and a disabled rail would only invite clicking.
 */
export function AuthShell({
  title,
  description,
  children,
  footer,
}: {
  title: string
  description?: string
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <div className="flex h-full items-center justify-center overflow-auto px-6 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-2.5">
          <LogoMark className="h-7 w-auto" />
          <span className="font-display text-[17px] tracking-tight">
            aCasa<span className="text-brand">Immobilien</span>
          </span>
        </div>

        <span className="bg-brand mb-3 block h-[3px] w-8" aria-hidden />
        <h1 className="font-display text-ink text-[24px] leading-tight">{title}</h1>
        {description && <p className="text-muted mt-2 text-sm leading-relaxed">{description}</p>}

        <div className="mt-7">{children}</div>

        {footer && (
          <div className="border-line text-faint mt-8 border-t pt-4 text-xs">{footer}</div>
        )}
      </div>
    </div>
  )
}

export function AuthError({ message }: { message: string | null }) {
  if (!message) return null
  return (
    <p className="border-danger/40 bg-danger/10 text-danger mt-4 border px-3 py-2 text-xs">
      {message}
    </p>
  )
}

export const PRIMARY_BUTTON =
  'bg-brand text-surface hover:bg-brand-strong w-full px-4 py-3 text-sm font-medium transition-colors disabled:opacity-40'
